import { render, staticRenderFns } from "./curationDetailPage.vue?vue&type=template&id=3b6e0c2a&scoped=true&"
import script from "./curationDetailPage.vue?vue&type=script&lang=js&"
export * from "./curationDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6e0c2a",
  null
  
)

export default component.exports